import React, { useEffect, useRef, useState } from 'react';
import "./User.scss"
import { useSelector, useDispatch } from 'react-redux';
import PostService from '../../../API/PostService';
import profilePhoto from '../../../images/user_icon.svg';
import { setCurrentUserAction } from '../../../store/currentUserReducer';
import { useFetching } from '../../../hooks/useFetching';
import { mainUrl } from '../../../constants/constants';
import Cookies from 'universal-cookie';

const User = () => {
	const elem = useRef();
	const dispatch = useDispatch();
	const currentUser = useSelector(state => state.currentUser.currentUser)
	const [open, setOpen] = useState(false);
	const [user, setUser] = useState(null);

	useEffect(() => {
		setTimeout(() => {
			document.addEventListener('click', documentClickHandler);
		}, [0])

		return () => document.removeEventListener('click', documentClickHandler);
	}, []);

	useEffect(() => {
		if (!currentUser) {
			fetchUserInfo();
		}
		setUser(currentUser);
	}, [currentUser])

	const [fetchUserInfo] = useFetching(async () => {
		const response = await PostService.getUserInfo()
		if (response.data.success && response.data.result !== false) {
			dispatch(setCurrentUserAction(response.data.result))
		}
	})

	const documentClickHandler = (e) => {
		if (!elem.current) return;
		if (!elem.current.contains(e.target)) {
			setOpen(false)
		}
	};

	const logout = async () => {
		fetchLogoutUser();
	}

	const [fetchLogoutUser] = useFetching(async () => {
		const response = await PostService.logout()
		if (response.data.success && response.data.result !== false) {
			dispatch(setCurrentUserAction(null));
			const cookies = new Cookies(null, { path: '/' });
			cookies.remove('CRM-AUTH');
			window.location.reload();
		}
	})

	return (
		
		<div className={"user" + (open ? ' open' : '')} ref={elem}>
			{user && (
				<button className="user__holder" onClick={() => setOpen(!open)}>
					{
						user.personal_photo_src && (
							<div className="user__photo">
								<img src={`${mainUrl}${user.personal_photo_src}`} alt={user.full_name} />
							</div>
						)
					}
					{
						!user.personal_photo_src && (
							<div className="user__photo">
								 <img src={profilePhoto} />
							</div>
						)
					}
					<div className="user__info">
						{/* Логин: <br></br> */}
						<span className='user__info-login'>
							{user.full_name ? user.full_name : user.login}
						</span>
					</div>
				</button>
			)}
			{open && (
				<div className="user__dropdown">
					<a className='profile' href={`/bitrix/admin/user_edit.php?lang=ru&ID=${user.id}`} target='_blank'>
						Профиль
					</a>
					<button className='logout' onClick={logout}>
						Выйти
					</button>
				</div>
			)}
		</div>
	);
};

export default User;
